import {Box, HBox} from '../../components/core/view';
import {
  FlatBarcode,
  ScannerMode,
} from '@buncha/components/composites/Scanner/type';
import {HomeScreens, ShopperScreens} from '@buncha/home/navigation/types';
import {
  ItemScannerAction,
  useGetBuyerDetails,
  useGetCatalogItemWrongItemScan,
  useGetLocation,
  useGetOrderItemById,
  useGetUpc,
  useItemScannerReducer,
  useScanUPCForAllItems,
  useUPCOrder,
  useUpdateOrderItemProperties,
} from '../hooks/ItemScanner';
import {
  OrderItem,
  OrderItemPropertiesParams,
  ScanUPCForAllItemsParams,
  ScanUPCParams,
  SelectedOption,
  Sensitivity,
  UpcWithAccuracyPercantage,
} from '../types/ItemScanner';
import {OrderItemStatus, UpcStatus} from '@buncha/batchDetails/types';
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {getClientType, getStoreName} from '@buncha/common/types/common';
import {useAppDispatch, useAppSelector} from '@buncha/config/redux/hooks';
import {useColorThemeType, useShadow} from '../../appStyles/hooks/theme';

import {AccuracyPercentageCheckValue} from '@buncha/config/utils/constants';
import {Analytics} from '@buncha/config/analytics/analytics';
import B2BLocationInStore from '../components/ItemDetail/B2BLocationInStore';
import {B2BScreens} from '@buncha/B2B/navigation/types';
import {EventType} from '@buncha/config/analytics/type';
import Header from '../../components/composites/Header/Header';
import If from '@buncha/components/conditional/If';
import ItemDetails from '../components/ItemScanner/ItemDetails';
import {ItemDetailsScreen} from '../navigation/types';
import {ItemScannerContext} from '../context/ItemScanner';
import {ItemScannerGlobalActions} from '../reducer';
import KeyboardAvoidLayout from '@buncha/components/composites/keyboardAvoidLayout';
import LoaderComponents from '@buncha/components/composites/CustomLoader/LoaderComponents';
import {ModalDetails} from '@buncha/onBoarding/types';
import {Modules} from '@buncha/utils/types';
import NSCSkipModal from '../components/ItemScanner/NSCSkipModal';
import ScanAgainButton from '../components/ItemScanner/ScanAgainButton';
import Scanner from '@buncha/components/composites/Scanner';
import {ToastType} from '@buncha/components/composites/notification/type';
import WeightAndQtyPill from '../components/ItemDetail/WeightAndQtyPill';
import WrongItemScanAlert from '../components/ItemScanner/Scanner/WrongItemScanAlert';
import {b2bNav} from '@buncha/B2B/navigation';
import {navigation} from '@buncha/config/navigation';
import {removeLeadingZeroes} from '@buncha/batchDetails/utils/ScannedAddItem';
import {useGetLocale} from '@buncha/localization/hooks';
import {useHasSafeAreaView} from '@buncha/utils/common';
import {useIsMeijerStore} from '@buncha/home/hooks/home';
import {useRoute} from '@react-navigation/native';
import {useToastMessage} from '@buncha/components/composites/notification';
import {useUpdateOrderItemStatus} from '@buncha/batchDetails/hooks/BatchDetails';

const ItemScanner = () => {
  const [state, dispatch] = useItemScannerReducer();
  const provider = useMemo(() => ({state, dispatch}), [dispatch, state]);
  const theme = useColorThemeType();
  const route = useRoute();

  const routeParams: any = route?.params;
  const orderItemId = Number(routeParams?.orderItemId);
  const stateOrderIds = state.buyerData?.map(buyer => buyer.orderItemId);
  const orderItemIds = stateOrderIds.length
    ? stateOrderIds
    : routeParams?.orderItemIds;
  const storeIndex = routeParams?.storeIndex;
  const isUPCMode = routeParams?.isUpcMode;
  const source = routeParams?.source;
  const storeMasterId =
    Number(routeParams?.storeMasterId) ||
    state?.item?.order?.run?.store?.storeMasterId ||
    0;
  const isAdjacentOOS = routeParams?.isAdjacentOOS;
  const conversationId = routeParams?.conversationId;
  const hasPriceTagAlreadyVerified = routeParams?.hasPriceTagAlreadyVerified;
  const quantity = routeParams?.quantity;

  const [upcImage, setUPCImage] = useState<string[]>(state.upcImages);
  const [wrongItemScanModal, setWrongItemScanModal] = useState<boolean>(false);
  const [skipModalOpen, setSkipModalOpen] = useState(false);
  const skipModalUpc = useRef('');
  const appDispatch = useAppDispatch();

  const {orderItemLoading, getOrderItemById} = useGetOrderItemById(dispatch);
  const {getBuyerDetails, buyerDetailsLoading} = useGetBuyerDetails(dispatch);
  const {getUpc, preLoadedUpcs, firstUpc} = useGetUpc();
  const {getCatalogItemForShopper} = useUPCOrder(dispatch);
  const {coordinates, getLocationWithPermission} = useGetLocation();
  const {scanUPCForAllItems} = useScanUPCForAllItems(dispatch);
  const {getCatalogItemById, catalogAPIstate} =
    useGetCatalogItemWrongItemScan(dispatch);
  const [showErrorToast] = useToastMessage(ToastType.Error);
  const {title} =
    useGetLocale(Modules.itemDetails, ItemDetailsScreen.ItemScanner) ?? {};
  const shadow = useShadow('2');

  const analyticsEvents = useRef<{[key: string]: boolean}>({});

  const runId = routeParams?.runId;
  const oldRunId = routeParams?.oldRunId;
  const catalogItemId = state.item?.catalogItemId;
  const returnPage = routeParams?.returnPage;
  const storeId = state?.item?.order?.run?.store?.id ?? 0;
  const isMeijerStore = useIsMeijerStore(storeId);

  const [openCameraModal, setOpenCameraModal] = useState(false);
  const [upcItemUrl, setUpcItemUrl] = useState('');
  const [selectedOption, setSelectedOption] = useState<SelectedOption>();
  const [upcPath, setUpcPath] = useState<string>();
  const [scannedUpc, setScannedUpc] = useState<string | undefined>();

  const toggleCameraModal = useCallback(() => {
    setOpenCameraModal(!openCameraModal);
  }, [openCameraModal]);

  const singleQuantiy = state?.buyerData?.[0]?.isItemPickedOnScan;

  const {scanUPCForCrowdSource} = useUPCOrder(dispatch);

  const isMeijer = useIsMeijerStore(storeId);
  const {upcOrderItem, selectedCatalogStoreForUPCRun} = useAppSelector(
    gState => gState.itemScanner,
  );

  const {updateOrderItemStatus, changeStatusState} = useUpdateOrderItemStatus();
  const {updateOrderItemProperties} = useUpdateOrderItemProperties();
  const {hasSafeArea} = useHasSafeAreaView();

  const onboardingState = useAppSelector(gState => gState.onboarding);
  const constants = onboardingState.constants;
  const priceTag = useMemo(() => {
    if (constants?.ENABLE_PRICE_TAG_FLOW === 'true')
      return !hasPriceTagAlreadyVerified;

    return false;
  }, [constants?.ENABLE_PRICE_TAG_FLOW, hasPriceTagAlreadyVerified]);

  const storeIdsForUnableToScanOptionVisible: any = useMemo(() => {
    return constants?.STORE_IDS_FOR_UNABLE_TO_SCAN_OPTION_VISIBLE ?? [];
  }, [constants?.STORE_IDS_FOR_UNABLE_TO_SCAN_OPTION_VISIBLE]);
  const categoriesForButton = JSON.parse(
    constants?.CATEGORIES_FOR_UNABLE_TO_SCAN_OPTION_VISIBLE || '[]',
  );

  const user = onboardingState.currentUser;
  const item = useMemo(() => {
    if (routeParams?.isUpcMode)
      return {
        name: upcOrderItem?.name,
        price: upcOrderItem?.price,
        isPriceUpdatable: false,
        itemImageUrl: state?.upcOrderItem?.itemImageUrls.largeImages[0],
        upcImages: [],
        catalogItemId: upcOrderItem?.catalogItemId,
        upcStatus: UpcStatus.pending,
        itemUnit: 1,
      };
    return state.item;
  }, [
    routeParams?.isUpcMode,
    state.item,
    state?.upcOrderItem?.itemImageUrls.largeImages,
    upcOrderItem?.catalogItemId,
    upcOrderItem?.name,
    upcOrderItem?.price,
  ]);

  const scanned = useMemo(() => {
    return (
      item?.upcStatus === UpcStatus.scanned ||
      item?.upcStatus === UpcStatus.imageSaved ||
      state?.upcCrowdSourceProcessCompleted ||
      state?.hasItemNotAvaibleFromESError
    );
  }, [
    item?.upcStatus,
    state?.hasItemNotAvaibleFromESError,
    state?.upcCrowdSourceProcessCompleted,
  ]);

  const navigateToRun = useCallback(() => {
    if (returnPage === ShopperScreens.OrderPackingPage)
      return navigation.navigate(HomeScreens.Shopper, {
        screen: ShopperScreens.OrderPackingPage,
        params: {runId: oldRunId ?? runId},
      });
    navigation.navigate(HomeScreens.Shopper, {
      screen: ShopperScreens.BatchDetailsPage,
      params: {runId: oldRunId ?? runId},
    });
  }, [oldRunId, returnPage, runId]);

  const closeBottomSheet = useCallback(() => {
    if (dispatch) dispatch(ItemScannerAction.setUpcImagesModal(false));
  }, [dispatch]);

  const upcScanHandler = useCallback(
    async (upc?: string, images?: string[]) => {
      if (!isUPCMode) return;
      let params: ScanUPCParams = {
        catalogItemId: upcOrderItem?.catalogItemId ?? 0,
        storeIndex: selectedCatalogStoreForUPCRun?.esIndex ?? '',
        orderItemId: routeParams?.orderItemId,
        lat: coordinates?.lat,
        lon: coordinates?.long,
        isUpcOrder: true,
      };
      if (images)
        params = {
          ...params,
          images: upcImage,
        };
      else
        params = {
          ...params,
          upc: upc,
        };
      await scanUPCForCrowdSource(params, () => {
        if (appDispatch) appDispatch(ItemScannerGlobalActions.clearItemState());
        getCatalogItemForShopper(orderItemId, routeParams?.isUpcMode, runId);
        if (dispatch) {
          dispatch(ItemScannerAction.setScannerExpanded(false));
          dispatch(ItemScannerAction.setScannerActive(false));
          dispatch(ItemScannerAction.setUPScanStatus(true));
        }
      });
      closeBottomSheet();
    },
    [
      appDispatch,
      closeBottomSheet,
      coordinates?.lat,
      coordinates?.long,
      dispatch,
      getCatalogItemForShopper,
      isUPCMode,
      orderItemId,
      routeParams?.isUpcMode,
      routeParams?.orderItemId,
      runId,
      scanUPCForCrowdSource,
      selectedCatalogStoreForUPCRun?.esIndex,
      upcImage,
      upcOrderItem?.catalogItemId,
    ],
  );

  const setScannerEnabled = useCallback(
    (val: boolean) => {
      dispatch(ItemScannerAction.setScannerActive(val));
    },
    [dispatch],
  );

  const onScanComplete = useCallback(() => {
    setUpcPath(undefined);
    setSelectedOption(undefined);
    setUpcItemUrl('');
    dispatch?.(ItemScannerAction.setItemNotAvaibleFromESError(false));
    if (singleQuantiy) return navigateToRun();
    dispatch?.(ItemScannerAction.setScannerExpanded(false));
    dispatch?.(ItemScannerAction.setUpcImagesModal(false));
  }, [dispatch, navigateToRun, singleQuantiy]);

  const updateReScanStatus = useCallback(
    async (status: OrderItemStatus, itemIds: number[], upc: string) => {
      await updateOrderItemStatus(
        runId,
        status,
        itemIds,
        undefined,
        undefined,
        isAdjacentOOS,
        [upc],
      );
    },
    [isAdjacentOOS, runId, updateOrderItemStatus],
  );

  const onScan = useCallback(
    async (
      upc: string,
      response?: boolean | UpcWithAccuracyPercantage,
      imageBase64?: string,
    ) => {
      let itemIds = orderItemIds || [orderItemId];
      upcScanHandler(upc);
      if (!catalogItemId || !storeIndex || !runId || isUPCMode) return;
      if (constants?.SKIP_UPC_FLOW === 'true' || isMeijer) {
        if (!itemIds) itemIds = [orderItemId];
        if (isMeijer && !response) {
          let modalDetails: ModalDetails | undefined;
          try {
            modalDetails = JSON.parse(
              constants?.ALLOW_SHOPPER_NON_NSC_ITEM_MODAL ?? '{}',
            );
          } catch {
            modalDetails = undefined;
          }
          if (modalDetails?.header?.length || modalDetails?.subheader?.length) {
            skipModalUpc.current = upc;
            return setSkipModalOpen(true);
          }
          return showErrorToast('Item does not match');
        }
        if (singleQuantiy) {
          if (
            returnPage === B2BScreens.B2BCheckout ||
            returnPage === ShopperScreens.OrderPackingPage
          )
            await updateReScanStatus(OrderItemStatus.packed, itemIds, upc);
          else
            await updateOrderItemStatus(
              runId,
              returnPage === ShopperScreens.OrderPackingPage
                ? OrderItemStatus.packed
                : OrderItemStatus.picked,
              itemIds,
              undefined,
              undefined,
              isAdjacentOOS,
              [upc],
            );
          onScanComplete();
        } else if (isMeijer) {
          if (
            returnPage === B2BScreens.B2BCheckout ||
            returnPage === ShopperScreens.OrderPackingPage
          )
            await updateReScanStatus(OrderItemStatus.packed, itemIds, upc);
          dispatch(ItemScannerAction.setScannerExpanded(false));
          setScannedUpc(upc);
        }
      } else {
        const params: ScanUPCForAllItemsParams = {
          upc: upc,
          catalogItemId: catalogItemId,
          storeIndex: storeIndex,
          runId: runId,
          lat: coordinates?.lat,
          lon: coordinates?.long,
          isAdjacentOOSItem: isAdjacentOOS,
          conversationId,
          orderItemIds,
        };
        if (
          response &&
          typeof response !== 'boolean' &&
          response?.accuracyPercentage > AccuracyPercentageCheckValue &&
          singleQuantiy
        ) {
          if (priceTag && imageBase64) setUpcPath(imageBase64);
          scanUPCForAllItems(params);
          return await updateOrderItemStatus(
            runId,
            returnPage === ShopperScreens.OrderPackingPage
              ? OrderItemStatus.packed
              : OrderItemStatus.picked,
            itemIds,
            priceTag && imageBase64 ? undefined : onScanComplete,
            undefined,
            isAdjacentOOS,
          );
        }
        const res = await scanUPCForAllItems(params);

        if (res)
          if (priceTag && imageBase64) setUpcPath(imageBase64);
          else onScanComplete();
        return res;
      }
      if (returnPage === B2BScreens.B2BCheckout)
        return b2bNav.B2BCheckout({
          runId,
          storeId: storeId,
          storeIndex: storeIndex,
        });
      if (returnPage === ShopperScreens.OrderPackingPage)
        return navigateToRun();
      if (!(priceTag && imageBase64)) onScanComplete();
    },
    [
      orderItemIds,
      orderItemId,
      upcScanHandler,
      catalogItemId,
      storeIndex,
      runId,
      isUPCMode,
      constants?.SKIP_UPC_FLOW,
      constants?.ALLOW_SHOPPER_NON_NSC_ITEM_MODAL,
      isMeijer,
      returnPage,
      storeId,
      navigateToRun,
      priceTag,
      onScanComplete,
      singleQuantiy,
      showErrorToast,
      updateReScanStatus,
      updateOrderItemStatus,
      isAdjacentOOS,
      dispatch,
      coordinates?.lat,
      coordinates?.long,
      conversationId,
      scanUPCForAllItems,
    ],
  );

  const onScanSuccess = useCallback(
    async (barcode: FlatBarcode) => {
      let upc = barcode.data ?? '';
      const trimmedUpc = removeLeadingZeroes(upc);
      if (isMeijer) upc = trimmedUpc.substring(0, trimmedUpc.length - 1);
      const response =
        (isMeijer && constants?.SKIP_B2B_UPC_FLOW === 'true') ||
        !preLoadedUpcs.current?.length ||
        preLoadedUpcs.current.find(
          preLoaded =>
            upc === preLoaded.upc ||
            (!isNaN(Number(upc)) && Number(preLoaded.upc) === Number(upc)) ||
            trimmedUpc === preLoaded.upc ||
            (!isNaN(Number(trimmedUpc)) &&
              Number(preLoaded.upc) === Number(trimmedUpc)),
        );
      await onScan(upc, response);
    },
    [constants?.SKIP_B2B_UPC_FLOW, isMeijer, onScan, preLoadedUpcs],
  );

  const openImagesBottomSheet = useCallback(() => {
    if (dispatch) dispatch(ItemScannerAction.setUpcImagesModal(true));
  }, [dispatch]);

  useEffect(() => {
    if (state.item && (catalogItemId || !isMeijerStore))
      getBuyerDetails(runId, catalogItemId, orderItemId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogItemId]);

  useEffect(() => {
    getLocationWithPermission();
    if (routeParams?.isUpcMode)
      getCatalogItemForShopper(orderItemId, routeParams?.isUpcMode, runId);
    else getOrderItemById(orderItemId, runId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderItemId]);

  useEffect(() => {
    const caatlogItemId = state.wrongScanCatalogItemId;
    if (caatlogItemId && storeIndex && !catalogAPIstate.loading)
      getCatalogItemById(caatlogItemId, storeIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.wrongScanCatalogItemId, storeIndex]);

  useEffect(() => {
    if (!item || !state.buyerData || analyticsEvents.current.scanPage) return;

    const upcItem: any = item;
    const sensitivity = state.buyerData?.[0]?.sensitivity;
    const sensitivityText =
      sensitivity &&
      [
        Sensitivity.priceAndWeightSensitive,
        Sensitivity.priceSensitive,
        Sensitivity.weightSensitive,
      ].includes(sensitivity)
        ? 'Weight sensitive'
        : 'Quantity sensitive';
    analyticsEvents.current.scanPage = true;
    if (upcItem?.isCustomItem)
      return Analytics.eventWithProps('Custom Item Details Page', {
        type: EventType.page,
        runId: runId,
        orderId: upcItem?.order?.id,
        orderItemId: orderItemId,
        orderItemName: item?.name,
        storeId: upcItem?.order?.run?.store.id,
        pageType: 'Custom Item',
        client: getClientType(isMeijerStore),
        storeType: getStoreName(String(storeId)),
        source: source,
      });
    return Analytics.eventWithProps('Barcode Scan Page', {
      type: EventType.page,
      runId: runId,
      orderId: upcItem?.order?.id,
      orderItemId: orderItemId,
      orderItemName: item?.name,
      storeId: upcItem?.order?.run?.store.id,
      pageType: sensitivityText,
      client: getClientType(isMeijerStore),
      storeType: getStoreName(String(storeId)),
      source: source,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, state.buyerData]);

  useEffect(() => {
    if (storeIndex && item?.catalogItemId && runId)
      getUpc(storeIndex, item?.catalogItemId, runId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item?.catalogItemId, storeIndex, runId]);

  useEffect(() => {
    if (!orderItemLoading) setUPCImage(state.upcImages);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderItemLoading]);

  useEffect(() => {
    if (!selectedOption || !catalogItemId) return;
    if (!(upcItemUrl || upcPath)) return;
    const params: OrderItemPropertiesParams = {
      catalogItemId: catalogItemId,
      runId: runId,
      args: {
        priceTag: selectedOption === SelectedOption.Yes,
        imageUrl: upcItemUrl,
      },
      photo: upcPath,
      storeIndex: storeIndex,
    };
    const fileName = `shopperId:${user?.id}_${new Date().getTime()}.jpg`;
    setTimeout(() => {
      updateOrderItemProperties(params, fileName, runId);
    }, 1);
    onScanComplete();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption, upcPath]);

  const handleWrongItemScanModal = useCallback(
    (isOpen: boolean) => {
      if (!isOpen && dispatch) {
        dispatch(ItemScannerAction.setWrongScanCatalogItemId(undefined));
        dispatch(ItemScannerAction.setScannerActive(true));
      }
      setWrongItemScanModal(isOpen);
    },
    [dispatch],
  );

  useEffect(() => {
    if (catalogAPIstate.data && !catalogAPIstate.loading)
      handleWrongItemScanModal(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogAPIstate.data, catalogAPIstate.loading]);

  useEffect(() => {
    let itemIds = orderItemIds || [orderItemId];
    if (state.hasItemNotAvaibleFromESError)
      updateOrderItemStatus(
        runId,
        OrderItemStatus.picked,
        itemIds,
        onScanComplete,
        undefined,
        isAdjacentOOS,
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.hasItemNotAvaibleFromESError]);

  const unableToScanHandler = useCallback(
    (eventType: string) => {
      Analytics.eventWithProps('Issue with barcode? Upload Image', {
        type: EventType.cta,
        source: eventType,
        client: getClientType(isMeijerStore),
        storeType: getStoreName(String(storeId)),
      });
      openImagesBottomSheet();
    },
    [isMeijerStore, openImagesBottomSheet, storeId],
  );

  const hasUnableToScanVisible = useMemo(() => {
    const orderItem = item as OrderItem;
    if (orderItem?.isCustomItem) return true;

    return (
      (storeMasterId &&
        storeIdsForUnableToScanOptionVisible.includes(storeMasterId || 0)) ||
      categoriesForButton?.includes(orderItem?.shopperCategory || '')
    );
  }, [
    item,
    storeMasterId,
    storeIdsForUnableToScanOptionVisible,
    categoriesForButton,
  ]);

  const headerMenu = useMemo(() => {
    return (
      <HBox style={[styles.header, {backgroundColor: theme?.text.blue[300]}]}>
        <If condition={isMeijerStore}>
          <B2BLocationInStore
            storeId={storeId}
            location={state.item?.itemLocation}
          />
        </If>
      </HBox>
    );
  }, [isMeijerStore, state.item?.itemLocation, storeId, theme?.text.blue]);

  const closeSkipModal = useCallback(() => {
    skipModalUpc.current = '';
    setSkipModalOpen(false);
    setScannerEnabled(true);
  }, [setScannerEnabled]);

  const skipModalBottomCTAhandler = useCallback(() => {
    onScan(skipModalUpc.current, true);
    skipModalUpc.current = '';
    setSkipModalOpen(false);
  }, [onScan]);

  const marginBottom = useMemo(() => {
    if (hasSafeArea && state.scannerActive) return 20;
    return 10;
  }, [hasSafeArea, state.scannerActive]);

  if (orderItemLoading || buyerDetailsLoading)
    return (
      <Box
        style={[
          StyleSheet.absoluteFill,
          styles.loader,
          {
            backgroundColor: theme?.background.white[100],
          },
        ]}>
        <LoaderComponents showBottomText={false} />
      </Box>
    );

  return (
    <ItemScannerContext.Provider value={provider}>
      <KeyboardAvoidLayout>
        <Header
          showDefaultLeftHeader={false}
          safeAreaViewColor={theme?.background.gray[200]}
          headerColor={theme?.background.blue[300]}
          style={{backgroundColor: theme?.background?.gray?.[200]}}
          hideBottomSafeArea
          headerRightComponent={headerMenu}>
          <ScrollView
            contentContainerStyle={styles.contentContainerStyle}
            style={styles.scrollView}>
            <If condition={item}>
              <ItemDetails
                item={item as OrderItem}
                title={title?.scanBarcode}
                scanned={scanned}
                openImagesBottomSheet={openImagesBottomSheet}
                showCaptureModeFunc={toggleCameraModal}
                isUPCMode={routeParams?.isUpcMode}
                hasUnableToScanBarcode={hasUnableToScanVisible}
                hasPriceTagVerified={hasPriceTagAlreadyVerified}
                isMeijerStore={isMeijerStore}
                catalogItemId={routeParams?.catalogItemId}
                barcode={firstUpc}
              />
            </If>
            <If
              condition={
                item?.catalogItemId && !openCameraModal && state.scannerExpanded
              }>
              <Box
                style={[
                  styles.containerStyles,
                  {
                    backgroundColor: theme?.background?.white?.[100],
                    marginBottom: marginBottom,
                  },
                  shadow,
                ]}>
                <If condition={!isUPCMode && item?.itemUnit}>
                  <HBox style={styles.weightPillContainer}>
                    <WeightAndQtyPill
                      itemUnit={item?.itemUnit}
                      quantity={quantity}
                    />
                  </HBox>
                </If>
                <Box style={styles.scannerContainer}>
                  <Scanner
                    mode={ScannerMode.singleScan}
                    scannerEnabled={state.scannerActive}
                    setScannerEnabled={setScannerEnabled}
                    onScan={onScanSuccess}
                    // expectedBarcodes={preLoadedUpcs?.map(p => p.upc)}
                  />
                </Box>
              </Box>
            </If>
            <If
              condition={
                !singleQuantiy && !state.scannerExpanded && scannedUpc
              }>
              <Box style={styles.scanAgain}>
                <ScanAgainButton
                  isUPCMode={isUPCMode}
                  unableToScanHandler={undefined}
                  hasUnableToScanVisible={false}
                  isAdjacentOosItem={isAdjacentOOS}
                  scannedUpc={scannedUpc}
                  loading={changeStatusState.loading}
                />
              </Box>
            </If>
          </ScrollView>
        </Header>
        <If condition={wrongItemScanModal}>
          <WrongItemScanAlert
            open={wrongItemScanModal}
            onClose={() => handleWrongItemScanModal(false)}
            catalogItem={catalogAPIstate.data}
            itemToBePicked={item as OrderItem}
            unableToScanHandler={() => unableToScanHandler('Wrong Item Scan')}
          />
        </If>
        <NSCSkipModal
          open={skipModalOpen}
          bottomCTAHandler={skipModalBottomCTAhandler}
          topCTAHandler={closeSkipModal}
          scannedBarcode={skipModalUpc.current ?? ''}
          expectedBarcode={firstUpc}
          itemId={item?.catalogItemId}
          itemName={item?.name}
          orderId={state?.item?.order?.id}
          runId={runId}
          orderItemIds={orderItemIds || [orderItemId]}
        />
      </KeyboardAvoidLayout>
    </ItemScannerContext.Provider>
  );
};

const styles = StyleSheet.create({
  loader: {
    opacity: 0.8,
    zIndex: 3,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  scrollView: {
    flex: 1,
  },
  contentContainerStyle: {
    justifyContent: 'flex-start',
  },
  menuItem: {
    marginRight: 10,
  },
  header: {
    flex: 1,
    justifyContent: 'flex-start',
  },
  containerStyles: {
    zIndex: 2,
    flex: 1,
    marginHorizontal: 15,
    borderRadius: 14,
    marginBottom: 10,
    marginTop: 10,
  },
  weightPillContainer: {
    position: 'absolute',
    zIndex: 5,
    right: 5,
    top: 10,
  },
  scannerContainer: {
    flex: 1,
    paddingTop: 50,
    overflow: 'hidden',
    borderRadius: 14,
  },
  headerTitle: {flex: 1, textAlign: 'center', marginRight: 30},
  scanAgain: {marginTop: 20},
});

export default React.memo(ItemScanner);
